import React from 'react';
import Lottie from 'react-lottie';

import fallback from '../../../assets/animations/fallback.json';
import className from './style.module.scss';

const FallBack: React.FC = () => {
	return (
		<div className={className.fallBack}>
			<Lottie width={150} height={150} options={options} />
		</div>
	);
};

const options = {
	loop: true,
	autoplay: true,
	animationData: fallback,
	rendererSettings: {
		preserveAspectRatio: 'xMidYMid slice',
	},
};

export default FallBack;
